export default {
	setMaterialsAndSupplies(state, value) {
		state.materialsAndSupplies = value;
	},
	setFetchLoading(state) {
		state.fetchLoading = !state.fetchLoading;
	},
	setLoading(state) {
		state.loading = !state.loading;
	},
};
